import { makeStyles } from "@mui/styles";

export const Style = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  borderLoading: {
    background: "#fff",
    padding: theme.spacing(3),
    borderRadius: 8,
    boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
  },
}));
